import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PURCHASE_REQUEST_AUDITS');
export const PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CONSTANTS
);
